export default __webpack_public_path__ + "static/t2-4287c477039d192ff3cfdfef4a95efc5.jpg";